<template>
  <div class="mb-horarios__darklight">
    <button
      type="button"
      class="mb-btn"
      :aria-label="`Cambiar a modo ${
        $colorMode.value === 'dark' ? 'claro' : 'oscuro'
      }`"
      @click="toggleColorMode"
    >
      <LucideSun
        v-if="userStore.theme === 'dark' || $colorMode.value === 'dark'"
        :size="16"
        class="stroke-current ml-0"
      />
      <LucideMoon v-else :size="16" class="stroke-current ml-0" />
    </button>
  </div>
</template>

<script lang="ts" setup>
import { useUserStore } from '~~/stores/userconfig';
const userStore = useUserStore();
const $colorMode = useColorMode();

const toggleColorMode = () => {
  $colorMode.preference = $colorMode.value === 'dark' ? 'light' : 'dark';

  userStore.setPreferencia({
    key: 'theme',
    value: $colorMode.preference,
  });

  umTrackEvent('theme-color', $colorMode.preference);
};
</script>
